import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "@environments/environment";
import { ConfirmComponent } from "@shared/dialogs/confirm/confirm.component";
import { catchError, Observable } from "rxjs";

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  private _dialog: MatDialog = inject(MatDialog);

  intercept(req: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only consider requests to our backend
    if (!req.url.includes(environment.backendUri) || req.url.includes('authinit')) return handler.handle(req);

    const path = req.url.split(environment.backendUri)[1];
    const newReq = req.clone({
      url: `${environment.backendUri}/${environment.version}${path}`
    });

    return handler.handle(newReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 409) {
          const res = this._dialog.open(
            ConfirmComponent,
            {data: 'There is a new UI version avaliable. Your page will refresh once you accept this message.'}
          );
          res.afterClosed().subscribe(() => {
            window.location.reload();
          });
        }
        throw err;
      })
    );
  }
}